"use strict";
// Written with ClaudeCode
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeDeep = void 0;
// Helper function to deep clone an object
var deepClone = function (obj) {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }
    if (obj instanceof Date) {
        return new Date(obj.getTime());
    }
    if (Array.isArray(obj)) {
        return obj.map(function (item) { return deepClone(item); });
    }
    if (typeof obj === 'object') {
        var cloned = {};
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                cloned[key] = deepClone(obj[key]);
            }
        }
        return cloned;
    }
    return obj;
};
// Helper function to check if a value is a plain object
var isPlainObject = function (obj) {
    return obj !== null &&
        typeof obj === 'object' &&
        obj.constructor === Object &&
        Object.prototype.toString.call(obj) === '[object Object]';
};
// Recursive merge function
var merge = function (target, source) {
    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            if (isPlainObject(source[key]) && isPlainObject(target[key])) {
                // Both are plain objects, merge recursively
                target[key] = merge(target[key], source[key]);
            }
            else {
                // Either source[key] is not an object, or target[key] doesn't exist/isn't an object
                // In this case, source[key] takes precedence
                target[key] = deepClone(source[key]);
            }
        }
    }
    return target;
};
var mergeDeep = function (a, b) {
    // Create a deep copy of a to avoid mutating the original
    var result = deepClone(a);
    return merge(result, b);
};
exports.mergeDeep = mergeDeep;
